import request from "@utils/request";

/**
 * 用户登录
 * @param data object 用户账号密码
 */
export function login(data) {
  return request.post("/login", data, { login: false });
}

/**
 * 用户手机号登录
 * @param data object 用户手机号 也只能
 */
export function loginMobile(data) {
  return request.post("/login/mobile", data, { login: false });
}

/**
 * 用户发送验证码
 * @param data object 用户手机号
 */
export function registerVerify(data) {
  return request.post("/register/verify", data, { login: false });
}

/**
 * 用户手机号注册
 * @param data object 用户手机号 验证码 密码
 */
export function register(data) {
  return request.post("/register", data, { login: false });
}

/**
 * 用户手机号修改密码
 * @param data object 用户手机号 验证码 密码
 */
export function registerReset(data) {
  return request.post("/register/reset", data, { login: false });
}

/*
 * 领取优惠券列表
 * */
export function getCoupon(q) {
  return request.get("/coupons", q, { login: false });
}

/*
 * 点击领取优惠券
 * */
export function getCouponReceive(id) {
  return request.post("/coupon/receive", { couponId: id }, { login: true });
}

/*
 * 批量领取优惠券
 * */
export function couponReceiveBatch(couponId) {
  return request.post("/coupon/receive/batch", { couponId });
}

/*
 * 我的优惠券
 * */
export function getCouponsUser(type) {
  return request.get("/coupons/user/" + type);
}

/*
 * 个人中心
 * */
export function getUser() {
  return request.get("/user");
}

/*
 * 用户信息
 * */
export function getUserInfo() {
  return request.get("/userinfo");
}

/*
 * 个人中心(功能列表)
 * */
export function getMenuUser() {
  return request.get("/menu/user");
}

/*
 * 地址列表
 * */
export function getAddressList(data) {
  return request.get("/address/list", data || {});
}

/*
 * 删除地址
 * */
export function getAddressRemove(id) {
  return request.post("/address/del", { id: id });
}

/*
 * 设置默认地址
 * */
export function getAddressDefaultSet(id) {
  return request.post("/address/default/set", { id: id });
}

/*
 * 获取默认地址
 * */
export function getAddressDefault() {
  return request.get("/address/default");
}

/*
 * 获取单个地址
 * */
export function getAddress(id) {
  return request.get("/address/detail/" + id);
}

/*
 * 修改 添加地址
 * */
export function postAddress(data) {
  return request.post("/address/edit", data);
}

/*
 * 购买保险
 * */
export function buyBaoxian(data) {
  return request.post("/baoxian/buy", data);
}

/*
 * 获取收藏产品
 * */
export function getCollectUser(page, limit) {
  return request.get("/collect/user", { page: page, limit: limit });
}

/*
 * 删除收藏产品
 * */
export function getCollectDel(id, category) {
  return request.post("/collect/del", { id: id, category: category });
}

/*
 * 批量收藏产品
 * */
export function postCollectAll(data) {
  return request.post("/collect/all", data);
}

/*
 * 添加收藏产品
 * */
export function getCollectAdd(id, category) {
  return request.post("collect/add", { id: id, category: category });
}

/*
 * 签到配置
 * */
export function getSignConfig() {
  return request.get("/sign/config");
}

/*
 * 签到里的签到列表
 * */
export function getSignList(page, limit) {
  return request.get("/sign/list", { page: page, limit: limit });
}

/*
 * 签到列表
 * */
export function getSignMonth(page, limit) {
  return request.get("/sign/month", { page: page, limit: limit });
}

/*
 * 签到用户信息
 * */
export function postSignUser(sign) {
  return request.post("/sign/user", sign);
}

/*
 * 签到
 * */
export function postSignIntegral(sign) {
  return request.post("/sign/integral", sign);
}

/*
 * 推广数据
 * */
export function getSpreadInfo() {
  return request.get("/commission");
}

/*
 * 推广人列表
 * */
export function getSpreadUser(screen) {
  return request.post("/spread/people", screen);
}

/*
 * 商户订单列表
 * */
export function merchantOrder(screen) {
  return request.post("merchant/order", screen);
}
/*
 * 消费券使用
 * */
export function merchantVoucher(screen) {
  return request.post("voucher/use", screen);
}

/*
 * 用户列表
 * */
export function userList(screen) {
  return request.post("user/list", screen);
}

/*
 * 用户余额消费券明细
 * */
export function userBillDetail(screen) {
  return request.post("user/bill/detail", screen);
}

/*
 * 消费券发放
 * */
export function voucherSend(screen) {
  return request.post("voucher/send", screen);
}
/*
 * 消费券汇总
 * */
export function voucherCount(screen) {
  return request.post("voucher/count", screen);
}

/*
 * 推荐商户列表
 * */
export function merchantSpread(screen) {
  return request.post("merchant/spread", screen);
}

/*
 * 推广人订单
 * */
export function getSpreadOrder(where) {
  return request.post("/spread/order", where);
}

/**
 * 赠股积分
 */
export function getIntegralLog(where) {
  return request.post("/user/integral_log", where);
}

/**
 * 赠股记录
 */
export function getPeiGuLog(where) {
  return request.post("/user/peigu_list", where);
}

/**
 * 信商资产记录
 */
export function getPaiLog(where) {
  return request.post("/pai/list", where);
}
/**
 * 用户信商资产信息
 */
export function getUserPai(where) {
  return request.post("/pai/info", where);
}
/**
 * 信商资产统计
 */
export function paiStatistics(where) {
  return request.post("/pai/statistics", where);
}
/**
 * 参与信商资产分配信息
 */
export function paiSendInfo() {
  return request.get("/pai/send/info");
}
/**
 * 商家赠送信商资产
 */
export function merchantDeal(where) {
  return request.post("/pai/merchant/deal", where);
}
/**
 * 用户交易信商资产
 */
export function userDeal(where) {
  return request.post("/pai/user/deal", where);
}
/**
 * 宜康宝积分
 */
export function getYikangbao() {
  return request.post("/user/yikangbao");
}

/*
 * 资金明细（types|0=全部,1=消费,2=充值,3=返佣,4=提现）
 * */
export function getCommissionInfo(q, types) {
  return request.get("/spread/commission/" + types, q);
}

/*
 * 40倍奖励
 * */
export function getMultiple(q, types) {
  return request.get("/spread/multiple/" + types, q);
}

/*
 * 资金明细（types|0=全部,1=消费,2=充值,3=返佣,4=提现）
 * */
export function getMillInfo(q, types) {
  return request.get("/spread/mill/" + types, q);
}

/*
 * 积分记录
 * */
export function getIntegralList(q) {
  return request.get("/integral/list", q);
}

/*
 * 提现银行
 * */
export function getBank() {
  return request.get("/extract/bank");
}

/*
 * 提现申请
 * */
export function postCashInfo(cash) {
  return request.post("/extract/cash", cash);
}

/*
 * 提现矿币
 * */
export function getMill() {
  return request.get("/mill/bank");
}

/*
 * 提现申请
 * */
export function postMillCashInfo(cash) {
  return request.post("/mill/cash", cash);
}

/*
 * 会员中心
 * */
export function getVipInfo() {
  return request.get("/user/level/grade");
}

/*
 * 会员中心 大于6寄
 * */
export function getVipInfoCompany() {
  return request.get("/user/level/gradeGtSix");
}

/*
 * 会员等级任务
 * */
export function getVipTask(id) {
  return request.get("/user/level/task/" + id);
}

/*
 * 资金统计
 * */
export function getBalance() {
  return request.get("/user/balance");
}

/*
 * 活动状态
 * */
export function getActivityStatus() {
  return request.get("/user/activity", {}, { login: false });
}

/*
 * 活动状态
 * */
export function getSpreadImg() {
  return request.get("/spread/banner");
}

/*
 * 用户修改信息
 * */
export function postUserEdit(data) {
  return request.post("/user/edit", data);
}

/*
 * 用户修改信息
 * */
export function getChatRecord(to_uid, data) {
  return request.get("user/service/record/" + to_uid, data);
}

/*
 * 用户修改信息
 * */
export function serviceList() {
  return request.get("user/service/list");
}

/*
 * 公众号充值
 * */
export function rechargeWechat(data) {
  return request.post("/recharge/wechat", data);
}

/*
 * 测试模拟微信回调
 * */
export function wechatNotify(data) {
  return request.post("/wechat/notify", data);
}

/*
 * 退出登录
 * */
export function getLogout() {
  return request.get("/logout");
}

/*
 * 绑定手机号
 * */
export function bindingPhone(data) {
  return request.post("binding", data);
}

/*
 * h5切换公众号登陆
 * */
export function switchH5Login() {
  return request.post("switch_h5", { from: "wechat" });
}
/*
 * 获取推广人排行
 * */
export function getRankList(q) {
  return request.get("rank", q);
}
/*
 * 获取佣金排名
 * */
export function getBrokerageRank(q) {
  return request.get("brokerage_rank", q);
}
/**
 * 检测会员等级
 */
export function setDetection() {
  return request.get("user/level/detection");
}

/**
 * 查询用户openid是否获取
 */
export function openidExists() {
  return request.get("user/openid");
}

/**
 * 用户登陆公众号地址
 */
export function wxLoginUrl() {
  return request.get("user/wx_login");
}

/**
 * 申请商家
 */
export function applyMerchant(data) {
  return request.post("apply/merchant", data);
}

/**
 * 上传图片 不验证登陆
 */
export function publicUploadImg(data) {
  return request.post("public/upload/image", data);
}

/**
 * 获取商家信息
 */
export function getMerchantInfo() {
  return request.get("merchant/info");
}

/**
 * 每周订单统计
 */
export function spreadOrderCount() {
  return request.get("spread/order/count");
}
/**
 * 每周商城积分专区奖励统计
 */
export function spreadAgentCount() {
  return request.get("spread/agent/count");
}
/**
 * 每周促销专区奖励统计
 */
export function spreadPromotionCount() {
  return request.get("spread/promotion/count");
}

/**
 * 每日消费达标奖励统计
 */
export function getDayAward() {
  return request.get("spread/day/count");
}
/**
 * 促销专区和商城奖励明细
 */
 export function getAllAward() {
  return request.get("spread/all/count");
}
/**
 * 商务专区奖励统计
 */
 export function getBusinessAward() {
  return request.get("spread/business/count");
}

/**
 * 推荐商家专区奖励统计
 */
 export function getRecommendMerchants() {
  return request.get("spread/merchant/count");
}
/**
 * 每周代理商奖励统计
 */
export function spreadMajordomoCount() {
  return request.get("spread/majordomo/count");
}
/**
 * 获取用户余额
 */
export function getUserBalance() {
  return request.get("user/balance/info");
}
/**
 * 用户交易余额
 */
export function balanceDeal(where) {
  return request.post("/user/balance/deal", where);
}
/**
 * 用户交易余额
 */
export function balanceXfq(where) {
  return request.post("/user/balance/xfq", where);
}
/**
 * 用户交易消费券
 */
export function xfqYe(where) {
  return request.post("/user/xfq/ye", where);
}
/**
 * 消费券全部
 */
export function spreadAward(where) {
  return request.post("/spread/award", where);
}

